/**
 * toolRegistry – Zuordnung tool_key → Frontend-Komponente fürs Tools-Portal.
 *
 * Neues Tool anbieten = 1 Zeile in der DB (tool_katalog, siehe Backend
 * endpoints/tools_portal/db.py) + 1 Eintrag hier.
 *
 * komprimieren_pdf und komprimieren_bild teilen sich EINE Seite — sie werden
 * im Portal zu einer Kachel „Komprimieren" zusammengefasst; die Freigaben
 * bestimmen nur, welche Dateitypen die Seite annimmt.
 */
import React from "react";
import VbVergleichPage from "../pages/VbVergleichPage";
import ToolsKomprimierungPage from "../pages/ToolsKomprimierungPage";
import ProtokollePage from "../pages/ProtokollePage";

const KOMPRIMIEREN_KEYS = ["komprimieren_pdf", "komprimieren_bild"];

/**
 * Liefert die Kachel-Liste für einen Benutzer.
 * tools: [{tool_key, name, icon}] aus /tools-portal/auth/me
 * → [{id, label, icon, render}]
 */
export function buildToolTiles(tools) {
  const keys = (tools || []).map((t) => t.tool_key);
  const tiles = [];

  const vb = (tools || []).find((t) => t.tool_key === "vb_vergleich");
  if (vb) {
    tiles.push({
      id: "vb_vergleich",
      label: vb.name || "PDF-Vergleich",
      icon: vb.icon || "🔍",
      render: () => <VbVergleichPage portal />,
    });
  }

  const prot = (tools || []).find((t) => t.tool_key === "protokolle");
  if (prot) {
    tiles.push({
      id: "protokolle",
      label: prot.name || "Protokolle",
      icon: prot.icon || "📝",
      render: () => <ProtokollePage portal />,
    });
  }

  const kompKeys = KOMPRIMIEREN_KEYS.filter((k) => keys.includes(k));
  if (kompKeys.length) {
    const allowed = {
      pdf: kompKeys.includes("komprimieren_pdf"),
      bild: kompKeys.includes("komprimieren_bild"),
      video: false,
    };
    tiles.push({
      id: "komprimieren",
      label:
        kompKeys.length === 2
          ? "Komprimieren"
          : allowed.pdf
          ? "PDF komprimieren"
          : "Bilder komprimieren",
      icon: "🗜️",
      render: () => <ToolsKomprimierungPage portal allowed={allowed} />,
    });
  }

  return tiles;
}
